<template>
  
</template>

<script setup>

    import { useVoskStore } from '@/stores/voskStore';
    import { computed } from "@vue/reactivity"
    import { ref , watch } from 'vue'

    // https://stackoverflow.com/questions/64117116/how-can-i-use-async-await-in-the-vue-3-0-setup-function-using-typescript

    import { createModel, KaldiRecognizer, Model , Recognizer } from "vosk-browser"
import { is } from '@babel/types';

    const emit = defineEmits(['process-words','microphone-status'])

    const props = defineProps({
        wordlist : {
            type : String,
            default : ""
        },
        trigger : Number,
        microphoneTrigger : {
            type : Number,
            default : 0
        }

        })

    var isListening = true

    const trigger = computed({
        get() {
            return props.trigger
        }
    })

    const microphoneTrigger = computed({
        get() {
            return props.microphoneTrigger
        }
    })

    watch (microphoneTrigger, () => {
        //console.log("microphoneTrigger trigger set",props.microphoneTrigger)
        setIsListening(!isListening)
    })

    watch (trigger, () => {
        //console.log("wordlist trigger set",props.wordlist)
        setWords()
    })

    function setIsListening(flag) {
        const voskStore = useVoskStore()
        isListening = flag
        voskStore.updateIsListening(flag)
        //console.log("in set is listening",flag)
        
    }

    setWords()

    async function setWords() {
        //console.log("*********************** SET WORDS",props.wordlist)
        const voskStore = useVoskStore()
        const voskFields = voskStore.getVoskFields
        var model = voskFields.model
        var recognizer = voskFields.recognizer
        var audioContext = voskFields.audioContext
        var source = voskFields.source
        var recognizerProcessor = voskFields.recognizerProcessor
        var channel = voskFields.channel

        var mediaStream = null

        setIsListening(voskFields.isListening)

        //console.log("new word list", props.wordlist)

        //console.log("Model",model)
        //console.log("recognizer",recognizer)
        //console.log("audio context",audioContext)
        //console.log("source",source)
        //console.log("recognizer processor",recognizerProcessor)

        channel = new MessageChannel();

        /*
        if (model != null)
            model.terminate()
        model = null
        */
       
        if (model == null) {
            //model = await createModel('model.tar.gz');
            model = await createModel("https://www.chessvis.com/model.tar.gz",-2)

            console.log("model after create",model)
        }
        else {
            model.unregisterRecognizer(recognizer.id)
            //recognizer.remove()
        }

        model.registerPort(channel.port1);
    
        //model = await createModel("https://www.chessvis.com/model.tar.gz",-1)
        //console.log("before new recognizer",model)

        const sampleRate = 48000;
        
        recognizer = new model.KaldiRecognizer(sampleRate, JSON.stringify([props.wordlist,'[unk]']));
        //console.log("after new recognizer",recognizer)
        //console.log("model after new recognizer",model)

        //const recognizer = new model.KaldiRecognizer(sampleRate);
        recognizer.setWords(true);

        
        recognizer.on("result", (message) => {
            const result = message.result;
            const text = result['text']
            if (text != "" && text != "[unk]") {
                //console.log("result",text)
                if (text == "command mike mute") {
                    setIsListening(false)
                    emit('microphone-status',false)
                }
                else
                if (text == "command mike listen") {
                    setIsListening(true)
                    emit('microphone-status',true)
                }
                else
                if (isListening)
                    emit("process-words",text)
            }
        });

        //console.log("before navigator mediadevices")
        try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: false,
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    channelCount: 1,
                    sampleRate
                },
            });

            //console.log("**** mediaStream",mediaStream)

            emit('microphone-status',isListening)

            //console.log("before new AudioContext")

            if (audioContext == null) {
                audioContext = new AudioContext();
                //await audioContext.audioWorklet.addModule('http://localhost:8080/recognizer-processor.js')

                //console.log("before await add module")
                await audioContext.audioWorklet.addModule('https://www.chessvis.com/recognizer-processor.js')

                //console.log("before new audioworklet node")
                recognizerProcessor = new AudioWorkletNode(audioContext, 'recognizer-processor', { channelCount: 1, numberOfInputs: 1, numberOfOutputs: 1 });
                //console.log("before post message")
            }

            recognizerProcessor.port.postMessage({action: 'init', recognizerId: recognizer.id}, [ channel.port2 ])
            //console.log("before recognizerprocessor connect")
            recognizerProcessor.connect(audioContext.destination);

            //console.log("before create media stream source")
            if (source == null) {
                source = audioContext.createMediaStreamSource(mediaStream);
                //console.log('before source connect')
                source.connect(recognizerProcessor);
            }
            //console.log('before update stored fields',mediaStream)
            voskStore.updateStoredVoskFields(model,audioContext,source,recognizer,recognizerProcessor,
                                    channel)

            //console.log("end of async")
        }
        catch {
            //console.log("*** error in media stream")
            mediaStream = null
            if (voskStore.getAlertShown == false)
                alert("Could not connect to microphone.\n\nNo speech recognition will be possible.\n\nIf you didn't 'allow' access to the microphone, please restart the program and do so.\n\nIf you did and got this message please contact support: henry@chessvis.com")
            isListening = false
            emit('microphone-status',isListening)
            voskStore.updateAlertShow(true)
            return
        }
    }
</script>

<style scoped>

</style>